var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',{staticClass:"style"},[(_vm.keywords)?_c('tracks',{attrs:{"filter":[{ type: 'style', value: this.styleId }, { type: 'search', value: _vm.keywords }]}}):_c('tracks',{attrs:{"filter":{ type: 'style', value: this.styleId }}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }